import { ActionType } from '../../abacus/enums/action-type.enum'
import { LinkType } from '../../abacus/enums/link-type.enum'
import { ResourceDefinition } from '../../abacus/interfaces/resource-definition.interface'

export const benefitDefinition: ResourceDefinition = {
  title: 'Benefits',
  nameSingular: 'Benefit',
  namePlural: 'Benefits',
  className: 'Benefit',
  mainIdentifier: 'name',
  slug: 'taxonomies/benefits',
  path: 'benefits',
  icon: 'icon-grid',
  hasDetailPage: false,
  hasListPage: true,
  buttons: [LinkType.CREATE],
  defaultLink: LinkType.EDIT,
  childrenThatPreventDelete: [],
  dropdownLinks: [
    {
      label: 'Edit',
      permission: 'editTaxonomies',
      action: (benefit) => ({
        type: ActionType.Link,
        link: {
          path: `${benefitDefinition.path}/${benefit.id}/edit`
        }
      })
    },
    {
      label: 'Delete',
      permission: 'deleteTaxonomies',
      action: (benefit) => ({
        type: ActionType.Delete,
        delete: {
          itemToDelete: benefit,
          definition: benefitDefinition
        }
      })
    }
  ]
}
